import { RouterEffects } from './app.effect';

export const effects: any[] = [RouterEffects];

export * from './app.effect';
